import { SiteLayoutComponent, SiteSection } from "shared/components/site-layout";
import { SocialLinksAd } from "shared/components/social-links-ad/SocialLinksAd";

export const DevPage = () => {
	return (
		<SiteLayoutComponent activeSection={SiteSection.Map}>
			<div style={{ flex: 1, padding: '10px' }}>
				<SocialLinksAd />
			</div>
		</SiteLayoutComponent>
	);
}